export const ENV = process.env.env;
export let DATA_API_SERVICE = "https://api.chargieengine.com";
export let CHARGE_SERVICE = "https://charge.chargieengine.com";
export let AUTH_SERVICE = "https://auth.chargieengine.com";
export const KW_TO_MW_THRESHOLD = 1000;
export const MW_DECIMAL_PLACES = 2;
export const KW_DECIMAL_PLACES = 1;
export const WEEK_SECONDS = 7 * 24 * 60 * 60 * 1000;
export const DEFAULT_CHART_POINT_SIZE = 0;
export const DEFAULT_DECIMAL_PLACES = 0;
export const DEFAULT_REFRESH_INTERVAL = 15 * 1000;
export const NO_VALUE_DISPLAY = "------";
export const PCSE_ORGANIZATION_ID = "a26a3318-8779-43ff-a8ca-ef5f694fc58f";
export const SUPPORT_PHONE = "(310) 967-3952";
export const SUPPORT_EMAIL = "support@chargie.com";

if (process.env.env === "local") {
  DATA_API_SERVICE = "http://localhost:8080";
  CHARGE_SERVICE = "http://localhost:4001";
  AUTH_SERVICE = "https://auth.develop.chargieengine.com";
  // Use this instead when developing the auth service locally
  // AUTH_SERVICE = "http://localhost:3000";
} else if (process.env.env === "staging") {
  DATA_API_SERVICE = "https://api.staging.chargieengine.com";
  CHARGE_SERVICE = "https://charge.staging.chargieengine.com";
  AUTH_SERVICE = "https://auth.staging.chargieengine.com";
} else if (process.env.env === "develop") {
  DATA_API_SERVICE = "https://api.develop.chargieengine.com";
  CHARGE_SERVICE = "https://charge.develop.chargieengine.com";
  AUTH_SERVICE = "https://auth.develop.chargieengine.com";
} else if (process.env.env === "gov") {
  DATA_API_SERVICE = "https://api2.demo.chargieengine.com";
  CHARGE_SERVICE = "https://charge2.demo.chargieengine.com";
  AUTH_SERVICE = "https://auth2.demo.chargieengine.com";
} else if (process.env.env === "prod") {
  DATA_API_SERVICE = "https://api.chargieengine.com";
  CHARGE_SERVICE = "https://charge.chargieengine.com";
  AUTH_SERVICE = "https://auth.chargieengine.com";
}
